import type { GetAvailableOptimizationsResponseAction } from './getAvailableOptimizations.action';
import type {
  GetConversionValueMappingRecommendationRequestAction,
  GetConversionValueMappingRecommendationResponseAction,
} from './getConversionValueMappingRecommendation.action';
import type { GetMappingTemplateRequestAction, GetMappingTemplateResponseAction } from './getMappingTemplate.action';
import type { GetMappingTemplatesOptionsResponseAction } from './getMappingTemplatesOptions.action';
import type { GetPostbacksConversionValueMappingResponseAction } from './getPostbacksConversionValueMapping.action';
import type { GetSkAdNetworkApplicationStatusResponseAction } from './getSkAdNetworkApplicationStatus.action';
import type {
  GetTargetEventsRecommendationsRequestAction,
  GetTargetEventsRecommendationsResponseAction,
} from './getTargetEventsRecommendations.action';
import type { SetActiveTemplateIdResponseAction } from './setActiveTemplateId.action';
import type { SetAscendingOnlyResponseAction } from './setAscendingOnly.action';
import type { SetCurrentConversionValueMappingResponseAction } from './setCurrentConversionValueMapping.action';
import type { SetCurrentTargetEventResponseAction } from './setCurrentTargetEvent.action';
import type {
  UpdateConversionValueMappingRequestAction,
  UpdateConversionValueMappingResponseAction,
} from './updateConversionValueMapping.action';
import type { UpdateSkAdNetworkApplicationStatusResponseAction } from './updateSkAdNetworkApplicationStatus.action';

export * from './getAvailableOptimizations.action';
export * from './getConversionValueMappingRecommendation.action';
export * from './getMappingTemplate.action';
export * from './getMappingTemplatesOptions.action';
export * from './getPostbacksConversionValueMapping.action';
export * from './getSkAdNetworkApplicationStatus.action';
export * from './getTargetEventsRecommendations.action';
export * from './setActiveTemplateId.action';
export * from './setAscendingOnly.action';
export * from './setCurrentConversionValueMapping.action';
export * from './setCurrentTargetEvent.action';
export * from './updateConversionValueMapping.action';
export * from './updateSkAdNetworkApplicationStatus.action';

export type SKANPostbacksConversionMappingAction =
  | GetAvailableOptimizationsResponseAction
  | GetConversionValueMappingRecommendationResponseAction
  | GetConversionValueMappingRecommendationRequestAction
  | GetMappingTemplateResponseAction
  | GetMappingTemplateRequestAction
  | GetMappingTemplatesOptionsResponseAction
  | GetPostbacksConversionValueMappingResponseAction
  | GetSkAdNetworkApplicationStatusResponseAction
  | GetTargetEventsRecommendationsResponseAction
  | GetTargetEventsRecommendationsRequestAction
  | SetActiveTemplateIdResponseAction
  | SetAscendingOnlyResponseAction
  | SetCurrentConversionValueMappingResponseAction
  | SetCurrentTargetEventResponseAction
  | UpdateConversionValueMappingResponseAction
  | UpdateConversionValueMappingRequestAction
  | UpdateSkAdNetworkApplicationStatusResponseAction;
